import axios from "@/config/axios-instance";
import { useQuery } from "vue-query";

const useUserService = () => {


    //Fetch User Data
    const useFetchUserService = (userId,isEnabled) => {
        const fetchUserRequest = (id) => {
            return axios.get(`/user/?userId=${id}`)
        }

        return useQuery(
            ['user',userId],
            ()=>fetchUserRequest(userId),
            {
                retry:1,
                enabled: isEnabled,
                select: (response) => response.data?.data
            }
        )

    }
    
    return {useFetchUserService}
};

export default useUserService;
